import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _72bcbfbf = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _375db0ae = () => interopDefault(import('../src/pages/_locale/index.vue' /* webpackChunkName: "pages/_locale/index" */))
const _690d0190 = () => interopDefault(import('../src/pages/_locale/create-alias.vue' /* webpackChunkName: "pages/_locale/create-alias" */))
const _263888a6 = () => interopDefault(import('../src/pages/_locale/jumbo.vue' /* webpackChunkName: "pages/_locale/jumbo" */))
const _cd37f16a = () => interopDefault(import('../src/pages/_locale/lider.vue' /* webpackChunkName: "pages/_locale/lider" */))
const _ca5e8c8a = () => interopDefault(import('../src/pages/_locale/logged.vue' /* webpackChunkName: "pages/_locale/logged" */))
const _a40e6a80 = () => interopDefault(import('../src/pages/_locale/login.vue' /* webpackChunkName: "pages/_locale/login" */))
const _f1e8bb30 = () => interopDefault(import('../src/pages/_locale/qcart.vue' /* webpackChunkName: "pages/_locale/qcart" */))
const _631feca4 = () => interopDefault(import('../src/pages/_locale/_alias/activity.vue' /* webpackChunkName: "pages/_locale/_alias/activity" */))
const _0c5cdc31 = () => interopDefault(import('../src/pages/_locale/_alias/configuration.vue' /* webpackChunkName: "pages/_locale/_alias/configuration" */))
const _1d184cf4 = () => interopDefault(import('../src/pages/_locale/_alias/home.vue' /* webpackChunkName: "pages/_locale/_alias/home" */))
const _3d074b8b = () => interopDefault(import('../src/pages/_locale/_alias/user/_id.vue' /* webpackChunkName: "pages/_locale/_alias/user/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _72bcbfbf,
    name: "index"
  }, {
    path: "/:locale",
    component: _375db0ae,
    name: "locale"
  }, {
    path: "/:locale/create-alias",
    component: _690d0190,
    name: "locale-create-alias"
  }, {
    path: "/:locale/jumbo",
    component: _263888a6,
    name: "locale-jumbo"
  }, {
    path: "/:locale/lider",
    component: _cd37f16a,
    name: "locale-lider"
  }, {
    path: "/:locale/logged",
    component: _ca5e8c8a,
    name: "locale-logged"
  }, {
    path: "/:locale/login",
    component: _a40e6a80,
    name: "locale-login"
  }, {
    path: "/:locale/qcart",
    component: _f1e8bb30,
    name: "locale-qcart"
  }, {
    path: "/:locale/:alias/activity",
    component: _631feca4,
    name: "locale-alias-activity"
  }, {
    path: "/:locale/:alias/configuration",
    component: _0c5cdc31,
    name: "locale-alias-configuration"
  }, {
    path: "/:locale/:alias/home",
    component: _1d184cf4,
    name: "locale-alias-home"
  }, {
    path: "/:locale/:alias/user/:id?",
    component: _3d074b8b,
    name: "locale-alias-user-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
